import React, { FormEvent, useEffect, useState } from "react";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import Logo from "../../components/common/Logo";
import loginBG from "../../assets/images/login_background.png";
import FormField from "../../components/common/FormField";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../store/reducers/mmymSlice";
import { useNavigate } from "react-router-dom";
import Validation from "../../utils/Validation";
import Notification from "../../components/common/notification/Notification";
import { forgetResetPasswordAction, setForgetResetPasswordAction, setSelectedForgetEmailAction } from "../../store/reducers/userSlice";
import { useSelector } from "react-redux";
interface FormElement {
  id: string;
  label?: string;
  placeholder: string;
  type: string;
  isRequired?: boolean;
  autocomplete?: string;
  inputProps?: any;
}

const formElements: FormElement[] = [
  {
    id: "email",
    label: "",
    placeholder: "Enter Email ID",
    type: "text",
    isRequired: true,
    autocomplete: "off",
    inputProps: {
      disabled: true,
    },
  },
  {
    id: "verificationCode",
    label: "",
    placeholder: "Enter Verification Code",
    type: "text",
    isRequired: true,
    autocomplete: "off",
  
  },
  // {
  //   id: "previousPassword",
  //   label: "",
  //   placeholder: "Enter Old Password",
  //   type: "password",
  //   isRequired: true,
  //   autocomplete: "off",
  // },
  {
    id: "proposedPassword",
    label: "",
    placeholder: "Enter New Password",
    type: "password",
    isRequired: true,
    autocomplete: "off",
  },
  {
    id: "confirmPassword",
    label: "",
    placeholder: "Enter Confirm Password",
    type: "password",
    isRequired: true,
    autocomplete: "off",
  },
];

const AccountResetPassword: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {selectedForgetEmail,isSetForgetPasswordSuccess} = useSelector((state: any) => state?.user);

  console.log("selectedForgetEmail",selectedForgetEmail);

  useEffect(() => {
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    };
  }, []);

  useEffect(()=>{
    if(isSetForgetPasswordSuccess){
      dispatch(setForgetResetPasswordAction(false));
      dispatch(setSelectedForgetEmailAction(null));
      navigate("/");
    }
  },[isSetForgetPasswordSuccess]);

  const handleSignout=()=>{
    dispatch(setSelectedForgetEmailAction(null));
      navigate("/forget-password");
      dispatch(setNotificationAction({ message: [], severity: "error" }));
  }

  const [formData, setFormData]: any = useState({});
  const [isActionCalled, setIsActionCalled] = useState(false);
useEffect(()=>{
  setFormData({
    ...formData,
    email:selectedForgetEmail
  })
},[selectedForgetEmail]);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    email: formData?.email,
    verificationCode:formData?.verificationCode || "",
    proposedPassword: formData?.proposedPassword || "",
    confirmPassword: formData?.confirmPassword || "",
  });

  const onChangeAction = (e: any) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    setFormData({
      ...formData,
      [id]: value,
    });
    resetValidator(e.target.id);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        console.log("api called");
        const { confirmPassword, ...payload } = formData;
        console.log("formData", formData);
        console.log("payload", payload);
        dispatch(forgetResetPasswordAction(payload));
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  return (
    <>
      <Grid
        container
        component="main"
        sx={{
          height: "100vh",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          position: "relative",
          zIndex: 1, // Ensure content is above the background image
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${loginBG})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.8, // Set the opacity of the background image
            zIndex: -1, // Place the background image behind the content
          },
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          // elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center vertically
            alignItems: "center", // Center horizontally
            width: "100%",
            "max-width": "100%",
            backgroundColor: "rgba(255, 255, 255, 0.50)",
            padding: "16px 0px",
            borderRadius: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "0px 16px", sm: "0px" },
              width: "80%",
            }}
          >
            <Logo isTitle={true} isPosition={true} />
            <Typography
              variant="h1"
              fontWeight={600}
              align="center"
              sx={{ fontSize: { xs: "2rem", sm: "3rem" }, color: "#000000" }}
            >
              Setup Your Password
            </Typography>
            <Typography
              variant="h5"
              fontWeight={600}
              sx={{ color: "#000000" }}
              mt={2}
            >
              Please choose your new password.
            </Typography>
            <Notification />
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                mt: 2,
                // display: "ruby",
                // justifyContent: "center", // Center children horizontally
                // flexDirection: "column", // Align children vertically
                // alignItems: "center",
                width: "100%",
              }}
            >
              {formElements?.map((field, i) => {
                return (
                  <FormField
                    {...{
                      ...field,
                      ...{
                        variant: "outlined",
                        isRounded: true,
                        onChange: onChangeAction,
                        onBlur: onBlurAction,
                        sx: {
                          marginTop: "0px !important",
                          "& input:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 1000px #fff inset",
                            WebkitTextFillColor: "#000",
                            background: "transparent",
                            height: "auto !important",
                            marginTop: "0px !important",
                          },
                        },
                        InputProps: {
                          ...(field?.inputProps && field?.inputProps),
                        },
                        error: error && error[field?.id],
                        value: formData ? formData[field?.id] : "",
                        helperText:
                          field?.id === "proposedPassword"
                            ? error &&
                              "Use at least 8 characters one uppercase letter one lowercase letter one special character and one number in your password"
                            : error && error[field?.id],
                      },
                    }}
                  />
                );
              })}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Button
                  onClick={handleSignout}
                  fullWidth
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    mt: 3,
                    mb: 2,
                    mr: 2,
                    width: "160px", // Adjust the width as needed
                    borderRadius: "20px", // Set a border radius for rounding
                    padding: "10px 16px",
                    textTransform: "capitalize",
                    backgroundColor: "#076C6B",
                    letterSpacing: 1.5,
                  }}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    mt: 3,
                    mb: 2,
                    width: "200px", // Adjust the width as needed
                    borderRadius: "20px", // Set a border radius for rounding
                    padding: "10px 16px",
                    textTransform: "capitalize",
                    backgroundColor: "#076C6B",
                    letterSpacing: 1.5,
                  }}
                >
                  Reset Password
                </Button>
              </div>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AccountResetPassword;
